const enum AccessIssue {
    AccessRestricted,
}
export default AccessIssue;

export const AccessIssues = [AccessIssue.AccessRestricted];
